module.exports = __webpack_public_path__ + "img/box_item_bg1.2bdb936a.png";